import { render, staticRenderFns } from "./Leitor.vue?vue&type=template&id=6201ec66"
import script from "./Leitor.vue?vue&type=script&lang=js"
export * from "./Leitor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports